@if ((finishedLoaded$ | async) !== true) {
  <div class="loading-area row root-loading-area">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
<router-outlet appTheme appScroller></router-outlet>
